import React, {useEffect } from 'react';  
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const SeniorExamination = () => {
    useEffect(() => {
        document.title = 'Senior Examination -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>   Academics</li> 
                 <li>Examination Schedule & Scheme of Evaluation</li> 
                 <li> Senior Examination</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Senior Examination</h1>
                        <h6>Schedule of Examinations </h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                    <div className="table-responsive maintable">
                        <table className="table">
                        <thead>
                                <tr align="center"> 
                                <th colspan="3"> CLASSES VI-VIII</th> 
                                </tr>
                            </thead>
                            <tbody> 
                                <tr className="colbg"> <td colspan="2"> Assessment </td> <td> Dates </td> </tr>
                                <tr> <td rowspan="2"> Pre Mid Term </td> <td> Periodic Test- I (PT I) </td> <td> 24 July – 31 July </td> </tr>
                                <tr> <td> Portfolio </td> <td> Regularly </td> </tr>
                                <tr> <td rowspan="4"> Mid Term </td> <td> Mid Term </td> <td> 27 Aug – 12 Sep </td> </tr>
                                <tr> <td> Portfolio </td> <td> Regularly </td> </tr>
                                <tr> <td> Activity&amp; Project Assessment </td> <td> August </td> </tr>
                                <tr> <td> Multiple Assessment </td> <td> August </td> </tr>
                                <tr> <td rowspan="2"> Post Mid Term </td> <td> Periodic Test- II (PT II) </td> <td> 02 Dec - 18 Dec </td> </tr>
                                <tr> <td> Portfolio </td> <td> Regularly </td> </tr>
                                <tr> <td rowspan="4"> Final Term </td> <td> Final Term Exam </td> <td> 25 Feb – 12 Mar &nbsp; </td> </tr>
                                <tr> <td> Portfolio </td> <td> Regularly </td> </tr>
                                <tr> <td> Activity &amp; Project Assessment </td> <td> January-February </td> </tr>
                                <tr> <td> Multiple Assessment </td> <td> January-February </td> </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="table-responsive maintable">
                        <table className="table">
                        <thead>
                                <tr align="center"> 
                                <th colspan="3">  CLASS IX</th> 
                                </tr>
                            </thead>
                            <tbody>
                                
                                    <tr className="colbg"> <td colspan="2"> Assessment </td> <td> Dates </td> </tr>
                                    <tr> <td rowspan="2"> Pre Mid Term </td> <td> Periodic Test- I (PT I) </td> <td> 24 July – 31 July </td> </tr>
                                    <tr> <td> Portfolio </td> <td> Regularly </td> </tr>
                                    <tr> <td rowspan="3"> Mid Term </td> <td> Periodic Test- II (PT II) </td> <td> 27 Aug – 12 Sep </td> </tr>
                                    <tr> <td> Multiple Assessment </td> <td> August </td> </tr>
                                    <tr> <td> Activity Assessment </td> <td> August </td> </tr>
                                    <tr> <td rowspan="2"> Post Mid Term </td> <td> Periodic Test- III (PT III) </td> <td> 02 Dec - 18 Dec </td> </tr>
                                    <tr><td>Portfolio</td><td>Regularly</td></tr>
                                    <tr> <td rowspan="4"> Final Term </td> <td> Final Term Exam </td> <td> 04 Feb- 18 Feb</td> </tr>
                                    <tr> <td> Portfolio </td> <td> Regularly </td> </tr>
                                    <tr> <td> Multiple Assessment </td> <td> January </td> </tr>
                                    <tr> <td> Activity Assessment </td> <td> January </td> </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="col-lg-12">
                    <div className="table-responsive maintable">
                        <table className="table">
                        <thead>
                                <tr align="center"> 
                                <th colspan="3">  CLASS X </th> 
                                </tr>
                            </thead>
                            <tbody>
                                 
                                    <tr className="colbg"> <td colspan="2"> Assessment </td> <td> Dates </td> </tr>
                                    <tr> <td> Class Test </td> <td> Class Test  </td> <td> 28 Apr – 05 May  </td> 
                                    </tr>
                                     <tr> <td rowspan="2"> Pre Mid Term </td> <td> Periodic Test- I (PT I)  </td> <td> 24 July – 31 July  </td> 
                                    </tr>
                                     <tr> <td> Portfolio  </td> <td> Regularly  </td> 
                                    </tr>
                                     <tr> <td rowspan="3"> Mid Term </td> <td> Periodic Test- II (PT II)  </td> <td> 27 Aug – 12 Sep  </td> 
                                    </tr>
                                     <tr> <td> Multiple Assessment  </td> <td> August  </td> 
                                    </tr>
                                     <tr> <td> Activity Assessment  </td> <td> August  </td> 
                                    </tr>
                                     <tr> <td> Post Mid Term </td> <td> Periodic Test- III (PT III)  </td> <td> 12 Nov – 24 Nov  </td> 
                                    </tr>
                                     <tr> <td rowspan="4"> Pre Board Exam </td> <td> Pre Board Exam  </td> <td> December/January  </td> 
                                    </tr>
                                     <tr> <td> Portfolio  </td> <td> Regularly  </td> 
                                    </tr>
                                     <tr> <td> Multiple Assessment  </td> <td> November/December  </td> 
                                    </tr>
                                     <tr> <td> Activity Assessment  </td> <td> November/December  </td> 
                                    </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                       <h6>Important</h6>
                       <p> <b>1. </b>   Dates for Mid Term & Final Term examination are tentative. </p>

                       <p> <b>2. </b>   As each exam has some weightage and absence in any one will negatively affect the overall result, it is advised to consult school authorities before planning your holidays to avoid absence in any of the exams. </p>
                       <div className="col-lg-6">
                       <div className="table-responsive maintable">
                       <table className="table">
                       <thead>
                               <tr align="center"> 
                               <th colspan="4">  CLASS XI  </th> 
                               </tr>
                           </thead>
                           <tbody> 
                               <tr className="colbg"> <td colspan="3"> Assessment </td> <td> Dates </td> </tr>
                               <tr> <td rowspan="3"> TERM - I </td> <td> Exam Series- I (ES-I) </td> <td> Theory </td> <td> 24 July – 31 July </td> </tr>
                               <tr> <td rowspan="2"> Half –Yearly Examination </td> <td> Practical </td> <td> August / September </td> </tr>
                               <tr> <td> Theory </td> <td>27 Aug – 12 Sep </td> </tr>
                               <tr> <td rowspan="3"> TERM - II </td> <td> Exam Series - II (ES-II) </td> <td> Theory </td> <td>02 Dec - 18 Dec </td> </tr>
                               <tr> <td rowspan="2"> Annual Examination &nbsp; </td> <td> Practical </td> <td> January </td> </tr>
                               <tr> <td> Theory </td> <td>04 Feb- 18 Feb </td> </tr> 
                           </tbody>
                           </table>
                       </div>
                       </div>
                       <div className="col-lg-6">
                       <div className="table-responsive maintable">
                       <table className="table">
                       <thead>
                               <tr align="center"> 
                               <th colspan="4">  CLASS XII  </th> 
                               </tr>
                           </thead>
                           <tbody> 
                               <tr className="colbg"> <td colspan="3"> Assessment </td> <td> Dates </td> </tr>
                                <tr> <td> 1 </td> <td> Exam Series – (ES-I) </td> <td> Theory </td> <td> 28 Apr – 05 May </td> </tr>
                                <tr> <td> 2 </td> <td> Exam Series – (ES-II) </td> <td> Theory </td> <td> 24 July – 31 July </td> </tr>
                                <tr> <td rowspan="2"> 3 </td> <td rowspan="2"> Half Yearly Examination </td> <td> Practical </td> <td> August/ September </td> </tr>
                                <tr> <td> Theory </td> <td> 27 Aug – 12 Sep </td> </tr>
                                <tr> <td> 4 </td> <td> Mock Pre Board Examination </td> <td> Theory </td> <td> 12 Nov – 24 Nov </td> </tr>
                                <tr> <td rowspan="2"> 5 </td> <td rowspan="2"> Pre-Board Examination </td> <td> Practical </td> <td> November/December </td> </tr>
                                <tr> <td> Theory </td> <td> December/January </td> </tr>
                            </tbody>
                           </table>
                       </div>
                       </div>
                       <h6>Important</h6>
                       <p> <b>1. </b> Dates for Half Yearly & Annual examination are tentative. </p>

                       <p> <b>2. </b>   As each exam has some weightage and absence in any one will negatively affect the overall result, it is advised to consult school authorities before planning your holidays to avoid absence in any of the exams. </p>
                       <h6>Scheme Of Evaluation</h6>
                       <p>Weightage to each exam (ES/Half Yearly/ Final) is according to CBSE/DOE.</p>
                       <h6>Promotion Policy</h6>

                    
                       <div className="col-lg-12">
<div className="table-responsive maintable">
<table className="table">

    <tbody> 
        <tr className="colbg"> <td> Classes </td> <td> Policy </td> </tr>
         <tr> <td> VIII &amp;IX </td> <td> Student has to secure 33% marks in each subject </td> </tr>
<tr> <td> XI </td> <td> Qualifying marks - 33% (Cumulative marks) in EACH subject (<em>33% in Theory, 33% in Practical &amp; 33% together</em>) </td> </tr>
     </tbody>
    </table>
</div>
</div>
<p>  Promotion Policy is subject to change as per the guidelines from DOE and CBSE.</p>
                       </div>
            </div>
        </div>
     </>
  )
}

export default SeniorExamination